/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChecklistCompletionSourceType } from './checklistCompletionSourceType';


export interface IntegrationChecklistItem { 
    completed: boolean;
    completed_at: string | null;
    key: IntegrationChecklistItem.KeyEnum;
    required: boolean;
    source_id: string | null;
    source_type: ChecklistCompletionSourceType;
}
export namespace IntegrationChecklistItem {
    export type KeyEnum = 'submit_partner_application' | 'sign_processing_agreement' | 'submit_w9_w8_and_voided_check' | 'setup_merchant_pricing' | 'create_secret_api_key' | 'create_publishable_api_key' | 'submit_merchant_application' | 'collect_a_payment' | 'initiate_a_refund' | 'build_a_checkout_form' | 'configure_webhooks' | 'collect_platform_fee' | 'payment_with_stored_pm' | 'create_checkout_session' | 'setup_subscription' | 'simulate_dispute' | 'invite_team_members' | 'configure_white_label' | 'customize_merchant_preferences';
    export const KeyEnum = {
        SUBMIT_PARTNER_APPLICATION: 'submit_partner_application' as KeyEnum,
        SIGN_PROCESSING_AGREEMENT: 'sign_processing_agreement' as KeyEnum,
        SUBMIT_W9_W8_AND_VOIDED_CHECK: 'submit_w9_w8_and_voided_check' as KeyEnum,
        SETUP_MERCHANT_PRICING: 'setup_merchant_pricing' as KeyEnum,
        CREATE_SECRET_API_KEY: 'create_secret_api_key' as KeyEnum,
        CREATE_PUBLISHABLE_API_KEY: 'create_publishable_api_key' as KeyEnum,
        SUBMIT_MERCHANT_APPLICATION: 'submit_merchant_application' as KeyEnum,
        COLLECT_A_PAYMENT: 'collect_a_payment' as KeyEnum,
        INITIATE_A_REFUND: 'initiate_a_refund' as KeyEnum,
        BUILD_A_CHECKOUT_FORM: 'build_a_checkout_form' as KeyEnum,
        CONFIGURE_WEBHOOKS: 'configure_webhooks' as KeyEnum,
        COLLECT_PLATFORM_FEE: 'collect_platform_fee' as KeyEnum,
        PAYMENT_WITH_STORED_PM: 'payment_with_stored_pm' as KeyEnum,
        CREATE_CHECKOUT_SESSION: 'create_checkout_session' as KeyEnum,
        SETUP_SUBSCRIPTION: 'setup_subscription' as KeyEnum,
        SIMULATE_DISPUTE: 'simulate_dispute' as KeyEnum,
        INVITE_TEAM_MEMBERS: 'invite_team_members' as KeyEnum,
        CONFIGURE_WHITE_LABEL: 'configure_white_label' as KeyEnum,
        CUSTOMIZE_MERCHANT_PREFERENCES: 'customize_merchant_preferences' as KeyEnum
    };
}


